module.exports = __webpack_public_path__ + "img/Monetary.8550d814.svg";